import createSelectors from './createSelectors';
import QuestionnairesRepositoryMetadataEntry from '../models/QuestionnairesRepositoryMetadataEntry';

const Select = createSelectors(QuestionnairesRepositoryMetadataEntry, {});

export default Select;
